export const getIntegrations = state => state.sites.current.integrations.data;
